import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import RouterFilterTagButton from '../../common/components/RouterFilterTagButton';
const MAX_UNEXPANDED_TAGS = 3;

const renderFilterTagButton = ({
  getTagI18nKey,
  getTagText,
  isPreview,
  onClick,
  queryField,
  value
}) => /*#__PURE__*/_jsx(RouterFilterTagButton, {
  className: "m-left-0 m-right-1",
  disabled: isPreview,
  onClick: onClick,
  queryField: queryField,
  value: value,
  children: getTagText ? getTagText(value) : getTagI18nKey ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: getTagI18nKey(value)
  }) : value
}, `${queryField}-${value}`);

export default function ExpandableTagsSection({
  getTagI18nKey,
  getTagText,
  isPreview,
  onTrackInteraction,
  queryField,
  tags
}) {
  const expandCount = tags.length - MAX_UNEXPANDED_TAGS;
  const shortenedTagsList = tags.slice(0, MAX_UNEXPANDED_TAGS);
  const [expanded, setExpanded] = useState(false);
  const trackInteraction = useCallback((action, eventProperties = {}) => {
    onTrackInteraction(action, Object.assign({}, eventProperties, {
      section: 'sidebar about',
      filter: queryField
    }));
  }, [onTrackInteraction, queryField]);
  const trackFilterTagClick = useCallback(value => {
    trackInteraction('click filter tag', {
      value
    });
  }, [trackInteraction]);

  if (expanded || tags.length <= MAX_UNEXPANDED_TAGS) {
    return /*#__PURE__*/_jsx(Fragment, {
      children: tags.map(value => renderFilterTagButton({
        getTagI18nKey,
        getTagText,
        isPreview,
        onClick: () => trackFilterTagClick(value),
        queryField,
        value
      }))
    });
  }

  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    wrap: "wrap",
    children: [shortenedTagsList.map(value => renderFilterTagButton({
      getTagI18nKey,
      getTagText,
      isPreview,
      onClick: () => trackFilterTagClick(value),
      queryField,
      value
    })), /*#__PURE__*/_jsxs(UIButton, {
      "aria-label": unescapedText(`marketplace-assets-ui.details.assetInfo.expandTags.${queryField}`),
      use: "transparent",
      onClick: () => {
        setExpanded(true);
        trackInteraction('click expand tags link');
      },
      className: "p-x-0 p-y-1",
      responsive: false,
      children: ["+", expandCount]
    })]
  });
}